module.exports = __webpack_public_path__ + "static/media/icn-canvasers-social.da7f56bb.svg";